import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { Button, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import NotificationsList from "../../features/manageNotifications/notificationsList";
import AddIcon from '@mui/icons-material/Add';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AdsClickOutlinedIcon from '@mui/icons-material/AdsClickOutlined';
import React from "react";

const ManageNotifications = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [type, setType] = React.useState('default');

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  return (
    <>
      <div className="main_title">
        <h1>Notification & Communication Center</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Notification & Communication Center
        </p>
      </div>
      <div className="stats_boxes gap_m">
        <a className="cards">
          <div className="data_top">
            <h2>
              42,435
              <p>Total Recipients</p>
            </h2>
            <figure className="blue">
              <SendOutlinedIcon fontSize="large" />
            </figure>
          </div>
        </a>

        <a className="cards">
          <div className="data_top">
            <h2>
              3
              <p>Sent Broadcasts</p>
            </h2>
            <figure className="sucess">
              <CheckCircleOutlinedIcon fontSize="large" />
            </figure>
          </div>
        </a>

        <a className="cards">
          <div className="data_top">
            <h2>
              10,944
              <p>Total Opened</p>
            </h2>
            <figure className="warning">
              <VisibilityOutlinedIcon fontSize="large" />
            </figure>
          </div>
        </a>

        <a className="cards">
          <div className="data_top">
            <h2>
              4,192
              <p>Total Clicked</p>
            </h2>
            <figure className="warning">
              <AdsClickOutlinedIcon fontSize="large" />
            </figure>
          </div>
        </a>
      </div>
      <div className="cards mt_20">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
            <div className="form">
              <div className="control_group">
                <Select
                  fullWidth
                  value={type}
                  onChange={handleTypeChange}
                >
                  <MenuItem disabled value="default">Select Type</MenuItem>
                  <MenuItem value="broadcast">Broadcast</MenuItem>
                  <MenuItem value="email">Email</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("/manage-notifications/add")}><AddIcon /> Add Notification</Button>
          </div>
        </div>

        <NotificationsList />
      </div>
    </>
  );
};

export default ManageNotifications;
